import type { SelectedCalculatorPrices } from "./getSelectedCalculatorPrice";
import type { CalcOptionsForContactUrl, PackageListState } from "./createURLToContactSection";

export interface CalculatorContactFormDataPayload {
  IsLeasing: boolean;
  IsNew: boolean;
  IsAuction: boolean;
  Period: number;
  Ow: number;
  OwPercent: number;
  Rv: number;
  RvPercent: number;
  Mileage: number;
  InstallmentPriceNetto: number;
  TotalFeesPercent: number;
  TotalPriceBrutto: number;
  AdditionalServices: number[];
}

export interface PrintOfferPayload {
  AuctionId: string;
  CalculatorContactFormData: CalculatorContactFormDataPayload;
  PromoCode?: string;
  ReffererId?: string;
}


export function buildPrintOfferPayload(
  calcOptions: CalcOptionsForContactUrl,
  auctionId: string,
  packageList: PackageListState,
  selectedPrices: SelectedCalculatorPrices | null,
  selectedMethod: number,
  isAfterLease: boolean,
  installmentPrice: number | undefined,
  totalPriceBrutto: number
): PrintOfferPayload | null {
  if (selectedMethod === 3) {
    return {
      AuctionId: auctionId,
      CalculatorContactFormData: {
        Ow: -1,
        OwPercent: -1,
        Mileage: -1,
        Period: -1,
        Rv: -1,
        RvPercent: -1,
        InstallmentPriceNetto: -1,
        TotalFeesPercent: -1,
        IsAuction: false,
        IsLeasing: false,
        IsNew: !isAfterLease,
        TotalPriceBrutto: totalPriceBrutto,
        AdditionalServices: []
      }
    };
  }

  if (installmentPrice == null || !selectedPrices) {
    return null;
  }

  const rent = calcOptions.LongTimeRentCalculatorValuesDTO;
  const leasing = calcOptions.LeasingCalculatorValues;

  const calcFormData: CalculatorContactFormDataPayload = {
    Ow: selectedPrices.owPrice ?? -1,
    Rv: selectedPrices.rvValuePLN ?? -1,
    InstallmentPriceNetto: installmentPrice,
    TotalFeesPercent: -1,
    IsAuction: false,
    IsLeasing: selectedMethod === 2,
    IsNew: !isAfterLease,
    TotalPriceBrutto: totalPriceBrutto,
    AdditionalServices: [],
    Period: -1,
    OwPercent: -1,
    RvPercent: -1,
    Mileage: -1
  };

  if (selectedMethod === 1) {
    calcFormData.Period = rent.Periods.find((x) => x.Status === true)?.Value ?? -1;
    calcFormData.Mileage = rent.Mileages.find((x) => x.Status === true)?.Value ?? -1;
    calcFormData.OwPercent = rent.Ows.find((x) => x.Status === true)?.Value ?? -1;
    calcFormData.RvPercent = -1;
    calcFormData.Rv = -1;
  } else if (selectedMethod === 2) {
    calcFormData.RvPercent = leasing.Rvs.find((x) => x.Status === true)?.Value ?? -1;
    calcFormData.Period = leasing.Periods.find((x) => x.Status === true)?.Value ?? -1;
    calcFormData.OwPercent = leasing.Ows.find((x) => x.Status === true)?.Value ?? -1;
    calcFormData.Mileage = -1;
  }

  for (const pkg of Object.keys(packageList)) {
    const entry = packageList[pkg];
    if (entry.isChecked) {
      calcFormData.AdditionalServices.push(entry.Value);
    }
  }

  return {
    AuctionId: auctionId,
    CalculatorContactFormData: calcFormData
  };
}
